module.exports = __webpack_public_path__ + "img/curved0.98b6019c.jpg";